module.exports = __webpack_public_path__ + "media/unauthenticated/password-accountant-19d9bfa8.png";